import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        compareQuestion: '=',
        counter: '=',
        title: '=',
        compareTitle: '='
    },
    template: `
        <h4>{{ vm.counter }}. {{ vm.question.nameWithoutHtml }}</h4>
        <ul class="ticks ticks02">
            <li><b>{{ 'survey.Total survey respondents:' | translate }} {{ vm.question.answerTotalCount }}</b></li>
        </ul>
        <dl ng-repeat="answer in vm.question.questionAnswers">
            <dt>{{ answer.text }}</dt>
            <dd>
                <span ng-if="vm.getAnswerCount(answer.id)">
                    <span ng-if="vm.compareTitle && vm.getAnswerCount(answer.id)" class="title" >
                        <strong class="ng-binding">{{ vm.title }}</strong>
                    </span>
                    <span class="result" ng-style="{ width: vm.getWidth(answer.id) }">
                        <span>{{ vm.getAnswerCount(answer.id) }} ({{ vm.getPercentage(answer.id) }}%)</span>
                    </span>
                </span>
                <span ng-if="vm.compareQuestion && vm.getCompareAnswerCount(answer.id)">
                    <span class="title" ng-if="vm.compareTitle && vm.getCompareAnswerCount(answer.id)">
                        <strong class="ng-binding">{{ 'survey.Comparison' | translate }}</strong>
                    </span>
                    <span ng-if="vm.compareQuestion && vm.getCompareAnswerCount(answer.id)"
                        class="result result02" ng-style="{ width: vm.getCompareWidth(answer.id), marginTop: '0px' }">
                        <span>{{ vm.getCompareAnswerCount(answer.id) }} ({{ vm.getComparePercentage(answer.id) }}%)</span>
                    </span>
                </span>
            </dd>
        </dl>
    `
})
export default class {
    constructor (lodash) {
        this.lodash = lodash;

        this.totalCount = 0;
        this.lodash.forEach(this.question.answerOptions, option => {
            this.totalCount += parseInt(option.answer_count, 0);
        });

        if (this.compareQuestion) {
            this.compareTotalCount = 0;
            this.lodash.forEach(this.compareQuestion.answerOptions, option => {
                this.compareTotalCount += parseInt(option.answer_count, 0);
            });
        }
    }

    getWidth (answerId) {
        if (!this.question.answerOptions[answerId]) {
            return 0;
        }
        const width = parseFloat(this.getAnswerCount(answerId) * 100 / this.getCalculatedTotalCount());
        return `${width}%`;
    }

    getCalculatedTotalCount () {
        if (!this.compareQuestion.answerTotalCount) {
            return this.question.answerTotalCount;
        }

        if (parseFloat(this.question.answerTotalCount) > parseFloat(this.compareQuestion.answerTotalCount)) {
            return this.question.answerTotalCount;
        }

        return this.compareQuestion.answerTotalCount;
    }

    getAnswerCount (answerId) {
        if (!this.question.answerOptions[answerId]) {
            return 0;
        }
        return this.question.answerOptions[answerId].answer_count;
    }

    getCompareWidth (answerId) {
        if (!this.compareQuestion.answerOptions[answerId]) {
            return 0;
        }
        const width = parseFloat(this.getCompareAnswerCount(answerId) * 100 / this.getCalculatedTotalCount());
        return `${width}%`;
    }

    getCompareAnswerCount (answerId) {
        if (!this.compareQuestion.answerOptions[answerId]) {
            return '';
        }
        return this.compareQuestion.answerOptions[answerId].answer_count;
    }

    getPercentage (answerId) {
        return Math.round(100 * this.getAnswerCount(answerId) / this.totalCount);
    }

    getComparePercentage (answerId) {
        return Math.round(100 * this.getCompareAnswerCount(answerId) / this.compareTotalCount);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/question/checkbox/index.js